import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Переиспользуемый компонент формы с лейблом, текстовым инпутом и кнопкой действия.
 * Предполагается использование внутри контейнеров со стилями (например, `join-room-form`, `create-room-form`).
 * Компонент не управляет валидацией, ошибки и уведомления обрабатываются внешним кодом.
 */
const LabeledActionForm = ({ label, value, onChange, buttonText, onSubmit, disabled, inputType = 'text', placeholder, autoComplete = 'off', }) => {
    return (_jsxs("form", { onSubmit: onSubmit, children: [_jsxs("label", { children: [label, _jsx("input", { type: inputType, value: value, onChange: (e) => onChange(e.target.value), placeholder: placeholder, autoComplete: autoComplete })] }), _jsx("button", { type: "submit", disabled: disabled, children: buttonText })] }));
};
export default LabeledActionForm;
